import { androidStoreAppUrl, appleStoreAppUrl } from "../../config";

const appleButton = <HTMLButtonElement>(
  document?.querySelector(".download__apple_store_button")
);
const googleButton = <HTMLButtonElement>(
  document?.querySelector(".download__google_play_button")
);
const externalLinkConfirmButton = <HTMLButtonElement>(
  document?.querySelector(".external-site-confirm-button")
);
const externalSite = <HTMLElement>document?.querySelector("#external-site");
const ui = <HTMLElement>document?.querySelector(".ui");
const downloadPage = <HTMLElement>document?.querySelector(".download");
const closeButton = <HTMLButtonElement>(
  document?.querySelector(".download__close-button")
);

export function openDownloadPage() {
  downloadPage.style.display = "flex";
  ui.style.display = "none";
}

closeButton?.addEventListener("click", () => {
  downloadPage.style.display = "none";
  ui.style.display = "flex";
});

appleButton?.addEventListener("click", () => {
  externalLinkConfirmButton?.setAttribute("data-href", appleStoreAppUrl);
  downloadPage.style.display = "none";
  externalSite.style.display = "flex";
});

googleButton?.addEventListener("click", () => {
  externalLinkConfirmButton?.setAttribute("data-href", androidStoreAppUrl);
  downloadPage.style.display = "none";
  externalSite.style.display = "flex";
});
